import React from 'react';
import { FieldPath, FieldValues, useFormContext } from 'react-hook-form';

import { Input } from '@eika/input';

import { useWatchError } from '@/domain/app';
import useText from '@/hooks/use-text';

import { V4Footer } from '../Footer';

import './Note.scss';

interface Props<T extends FieldValues> {
    onClose: () => void;
    maxLength?: number;
    fieldName: FieldPath<T>;
}

export const Note = <T extends FieldValues>({ onClose, maxLength = 35, fieldName }: Props<T>) => {
    const text = useText();
    const methods = useFormContext();

    const error = useWatchError<T>(fieldName, 'pay.validation.kid.illegalLength');

    const handleClick = async () => {
        if (!error) {
            const valid = await methods.trigger(fieldName);
            if (valid) {
                onClose();
            }
        } else {
            onClose();
        }
    };

    return (
        <div className="note__container">
            <Input
                id="noteReceiver"
                inputMode="numeric"
                className="note__input"
                placeholder={text.transferNotePlaceholder}
                maxLength={maxLength}
                error={error}
                {...methods.register(fieldName)}
            />

            <V4Footer onCancel={onClose} next={handleClick} />
        </div>
    );
};
